import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  imageContainer: {},
  thumbnailContainer: {
    width: 'auto',
  },
  spinnerContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },
  leftNav: {
    top: '45%',
    position: 'absolute',
    zIndex: 99,
  },
  rightNav: {
    top: '45%',
    position: 'absolute',
    zIndex: 99,
    right: 0,
  },
  thumbnailImg: {
    flex: 1,
    objectFit: 'cover',
    width: 'inherit',
    height: 'inherit',
  },
  thumbnailImgContainer: {
    height: '10vh',
    width: '10vh',
    display: 'flex',
  },
}))

export default useStyles
